import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-info-dialog',
    template: `
    <div>{{description | translate}}</div>`,
    imports: [TranslateModule]
})
export class InfoDialogComponent {
  @Input() description: string
}
